import { BIDC_PAGE_NAMESPACES } from "@/constants/bidc-page-namespaces";

export const PHP_TO_REACT_SHORTCUT_COMMANDS = [
  "focus-page-search",
  "scheduler-previous-period",
  "scheduler-next-period",
  "scheduler-today",
  "scheduler-day-view",
  "scheduler-week-view",
  "scheduler-month-view",
] as const;

export const REACT_TO_PHP_SHORTCUT_COMMANDS = ["focus-global-search"] as const;

export const PHP_TO_REACT_SHORTCUT_NAMESPACES = [
  BIDC_PAGE_NAMESPACES.EVENTS,
  BIDC_PAGE_NAMESPACES.EVENTS_CALENDAR,
] as const;

export const SHORTCUT_COMMAND_ERRORS = [
  "unknown_command",
  "missing_handler",
  "unsupported_channel",
  "unsupported_namespace",
  "channel_unavailable",
  "handler_failed",
  "send_failed",
  "invalid_response",
] as const;
